// @ts-nocheck

import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"

//@ts-ignore
import cellEditFactory from "react-bootstrap-table2-editor"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"

import { Col, Row, Button } from "reactstrap"

interface Props {
	produtos: Array<any>
	columnsProdutos: any
	unidade: any
	valor: any
	somaValorProdutos: any
	beforeSaveCellProduto: Function
	handleRedistruibuirPorProdutos: Function
}

const TableProdutos: React.FC<Props> = ({
	produtos,
	columnsProdutos,
	unidade,
	valor,
	somaValorProdutos,
	beforeSaveCellProduto,
	handleRedistruibuirPorProdutos,
}) => {
	const [data, setData] = useState([]) //Lista para receber produtos adicionados
	const [reload, setReload] = useState(false)

	useEffect(() => {
		console.log("####### USE EFFECT EM TABLEPRODUTOS da LISTA PRODUTO ########")
		console.log(reload)
		setData([])
		if (produtos && produtos.length > 0) {
			setReload(true)
		} else {
			//@ts-ignore
			setData(produtos)
			setReload(false)
		}
	}, [produtos])

	useEffect(() => {
		console.log("####### USE EFFECT RELOAD TABELA PRODUTO ########")
		console.log(reload)
		if (reload) {
			//@ts-ignore
			setData(produtos)
			setReload(false)
		}
	}, [reload])

	return (
		<>
			<Row>
				<Col className="col-12">
					<ToolkitProvider
						//data={meta ? (meta.produtos ? meta.produtos : []) : []}
						data={data ? data : []}
						keyField="produto_id"
						//@ts-ignore
						columns={columnsProdutos}
					>
						{(props) => (
							<div className="table-responsive py-4">
								<BootstrapTable
									{...props.baseProps}
									noDataIndication={() => "Nenhum produto adicionado"}
									bootstrap4={true}
									bordered={false}
									cellEdit={cellEditFactory({
										mode: "click",
										blurToSave: true,
										beforeSaveCell: beforeSaveCellProduto,
									})}
								/>
							</div>
						)}
					</ToolkitProvider>
				</Col>
			</Row>
			<div>
				{unidade && unidade == "M"
					? `Soma parcial: R$ ${parseFloat(somaValorProdutos).toFixed(2)}  /  Saldo: R$ ${
							valor
								? parseFloat((valor - somaValorProdutos).toFixed(2)).toFixed(2)
								: parseFloat((0 - somaValorProdutos).toFixed(2)).toFixed(2)
					  }`
					: //@ts-ignore
					  `Soma parcial: ${parseInt(somaValorProdutos)}  /  Saldo: ${
							valor
								? parseInt(valor - somaValorProdutos)
								: parseInt(0 - somaValorProdutos)
					  }`}

				{/* <Button
          color="primary"
          type="button"
          outline
          //@ts-ignore
          onClick={handleRedistruibuirPorProdutos}
          className="btn-icon btn-3 btn-sm"
          title='Redistribuir Meta por Produtos Automaticamente'
          style={{ marginLeft: 15 }}
          disabled={!(produtos && produtos.length > 0)}
        >
          <span className="btn-inner--icon">
            <i className="fas fa-divide"></i>
          </span>
          <span className="btn-inner--text">Redistribuição</span>
        </Button> */}
			</div>
		</>
	)
}

export default TableProdutos
